module.exports = __webpack_public_path__ + "img/gift-coin.26cfc490.svg";